<template>
  <div class="list-wrap">
    <div class="download-data" @click="exportData">导出数据</div>
    <!-- 时间容器 -->
    <div class="header-wrap">
      <div class="date-wrap">
        <div class="desc">时间</div>
        <div class="date-selector">
          <div class="date-field" @click="changeDate(1)">
            {{ startDate | currenDate }}
          </div>
          <div class="range">—</div>
          <div class="date-field" @click="changeDate(2)">
            {{ endDate | currenDate }}
          </div>
          <div class="select-box">
            <div
              :class="[item.value === dayValue ? 'active item' : 'item']"
              v-for="(item, index) in dayNum"
              :key="index"
              @click="changeDay(item)"
            >
              {{ item.desc }}
            </div>
          </div>
        </div>
      </div>
      <!--排序-->
      <div class="sort-wrap">
        <div class="desc">排序</div>
        <div class="sort-box">
          <div
            :class="[item.value === pageInfo.sortType ? 'active item' : 'item']"
            :key="index"
            v-for="(item, index) in sortData"
            @click="changeSort(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="data-wrap" v-if="pageInfo.total">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div
            class="item"
            v-for="(item, index) in tableData"
            :key="index"
            @click="navToDetail(item)"
          >
            <div class="top">
              <div class="img-wrap">
                <img class="map-img" :src="item.url" v-if="item.url" />
                <img class="map-img" src="@/assets/images/img_map_no_url.png" v-else />
                <img
                  v-if="item.ctype === 1"
                  class="corner"
                  src="@/assets/images/corner_works_map.png"
                  alt="corner"
                />
                <img
                  v-if="item.ctype === 2"
                  class="corner"
                  src="@/assets/images/corner_works_game.png"
                  alt="corner"
                />
              </div>
              <div class="right">
                <div class="title">
                  {{ item.name }}
                </div>
                <div class="label">
                  <div class="label1" v-if="item.label">
                    {{ item.label | _regroupMapType }}
                  </div>
                  <template v-if="item.open_svr">
                    <div
                      class="label2 success"
                      v-if="item.open_svr == '审核成功'"
                    >
                      {{ item.open_svr }}
                    </div>
                    <div class="label2" v-else-if="item.open_svr == '审核中'">
                      {{ item.open_svr }}
                    </div>
                    <div class="label2" v-else>
                      {{ item.open_svr }}
                    </div>
                  </template>
                </div>
                <div class="time">{{ item.create_time }}</div>
              </div>
            </div>
            <div class="bottom">
              <div class="top-box">
                <div class="value">
                  浏览次数 {{ item.nowview_counts | transWan }}
                </div>
                <div class="value-custom">
                  下载次数 {{ item.nowdownload_counts | transWan }}
                </div>
                <div class="value">
                  游戏次数 {{ item.nowplay_counts | transWan }}
                </div>
              </div>
              <div class="bottom-box">
                <div class="value">
                  游戏时长(分) {{ item.nowplay_times | transWan }}
                </div>
                <div class="value-custom">
                  评论数 {{ item.nowcomment_counts | transWan }}
                </div>
                <div class="value">
                  收藏数 {{ item.nowcollect_counts | transWan }}
                </div>
              </div>
            </div>
          </div>
          <div class="complete-tip" v-if="tableData.length >= pageInfo.total">
            到底啦！
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <NoData v-else></NoData>
    <!-- 日期选择器开始时间-->
    <van-popup v-model="showStart" position="bottom">
      <van-datetime-picker
        v-model="startDate"
        type="date"
        :max-date="maxStartDate"
        @confirm="updateStartDate"
      >
      </van-datetime-picker>
    </van-popup>
    <van-popup v-model="showEnd" position="bottom">
      <van-datetime-picker
        v-model="endDate"
        type="date"
        :max-date="maxEndDate"
        @confirm="updateEndDate"
      >
      </van-datetime-picker>
    </van-popup>
    <!-- </div>   -->
  </div>
</template>

<script>
// import SimpleTable from '@/components/SimpleTable';
import { regroupMapType } from '@/utils/index.js';
import NoData from '@/components/NoData.vue';
import {
  getMapList,
  getActiveData,
  getMotivate,
  downloadData,
} from '@/api/charts';
import { formatDate } from '@/utils';
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000;
export default {
  components: {
    // SimpleTable,
    NoData,
  },
  mounted() {
    this.init();
  },
  filters: {
    currenDate(date) {
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return year + '-' + month + '-' + day;
    },
    //判断数据是否超过一万
    transWan(value) {
      if (value < 10000) return value;
      else {
        return (value / 10000).toFixed(1) + '万';
      }
    },
    _regroupMapType(val) {
      return regroupMapType(val);
    },
  },
  data() {
    return {
      isLoading: false,
      showStart: false,
      loading: false,
      finished: false,
      startValue: 0,
      endValue: 0,
      refreshing: false, //下拉刷新
      showEnd: false,
      minStartDate: '',
      minEndDate: '',
      maxEndDate: new Date(),
      maxStartDate: new Date(),
      searchParams: {
        sort_type: 0,
        page: 1,
        page_size: 10,
      },
      tableData: [],
      dayNum: [
        {
          desc: '7天',
          value: 7,
        },
        {
          desc: '30天',
          value: 30,
        },
        {
          desc: '90天',
          value: 90,
        },
      ],
      sortData: [
        {
          title: '发布时间',
          value: 4,
        },
        {
          title: '总下载',
          value: 2,
        },
        {
          title: '总时长',
          value: 10,
        },
        {
          title: '评论数',
          value: 11,
        },
      ],
      range: 4,
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
        sortType: 4,
      },
      singelData: {},
      startDate: '',
      endDate: '',
      dayValue: 7,
      mapColumns: [
        { prop: 'name', label: '地图名称' },
        { prop: 'today_download', label: '今日下载(预估)' },
        { prop: 'yesterday_download', label: '昨日下载' },
        { prop: 'total_download', label: '总下载' },
        { prop: 'yesterday_ad_count', label: '昨日广告展示' },
        { prop: 'ad_count', label: '总广告展示' },
        { prop: 'time', label: '上传日期', width: 100 },
      ],
      mapList: [],
      dataTotal: 0,
    };
  },
  computed: {
    sortOptions() {
      return this.mapColumns.map((item, index) => ({
        text: item.label,
        value: index,
      }));
    },
  },
  created() {
    //初始化时间
    const currTime = new Date(new Date().toDateString()).getTime();
    this.startDate = new Date(currTime - ONE_WEEK_TIME);
    this.endDate = new Date(currTime - ONE_DAY_TIME);
    this.minStartDate = new Date(currTime - 90 * 24 * 60 * 60 * 1000);
    this.minEndDate = new Date(currTime - 90 * 24 * 60 * 60 * 1000);
    this.endValue = this.currenDate(this.endDate);
  },
  methods: {
    //导出作品数据
    async exportData() {
      let start_time = parseInt(this.startDate.getTime() / 1000, 10);
      let end_time = parseInt(this.endDate.getTime() / 1000, 10);
      let data = {
        start_time: start_time,
        end_time: end_time,
      };
      try {
        const res = await downloadData(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    //下载数据
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    fetchMap() {
      const _this = this;
      this.rankClick(this.searchParams.sort_type);
      this.fetchMapList();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onLoad() {
      this.pageInfo.page = this.pageInfo.page + 1;
      this.getMapList();
    },
    updateStartDate() {
      this.range = 4;
      this.pageInfo.page = 1;
      this.tableData = []; //清空数组
      this.getMotivateData();
      this.getMapList();
      this.showStart = false;
    },
    updateEndDate() {
      this.range = 4;
      this.pageInfo.page = 1;
      this.tableData = []; //清空数组
      this.getMotivateData();
      this.getMapList();
      this.showEnd = false;
    },
    init() {
      // this.startDate=
      // this.fetchMapList();
      // this.proListShow();
      this.getMotivateData();
      this.getMapList();
    },
    //转换时间为年月日
    currenDate(date) {
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return year + '' + month + '' + day;
    },
    //作品列表展示埋点
    proListShow() {
      this.$log('product_list_show', 85413, { v7: 2 });
    },
    //排序方式埋点
    rankClick(index) {
      this.$log('rank_click', 85414, { v7: 2, v8: index + 1 });
    },
    //选择时间范围
    changeDate(index) {
      if (index === 1) {
        this.showStart = true;
      } else {
        this.showEnd = true;
      }
    },
    //切换日期范围
    changeDay(item) {
      this.pageInfo.page = 1;
      this.tableData = [];
      this.dayValue = item.value;
      let startTime = '';
      const nowTime = new Date(new Date().toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      const ONE_DAY = 24 * 60 * 60 * 1000;
      let endTime = nowTime - 1;
      if (this.dayValue == 7) {
        startTime = nowTime - 7 * ONE_DAY;
        this.range = 2;
      } else if (this.dayValue == 30) {
        startTime = nowTime - 30 * ONE_DAY;
        this.range = 3;
      } else {
        startTime = nowTime - 90 * ONE_DAY;
        this.range = 4;
      }
      this.startDate = new Date(startTime);
      this.endDate = new Date(endTime);
      console.log('结束时间变化---', this.endDate, endTime);
      this.getMotivateData();
      this.getMapList();
    },
    //切换排序方式
    changeSort(item) {
      this.pageInfo.sortType = item.value;
      this.range = 4;
      this.pageInfo.page = 1;
      this.tableData = [];
      this.getMotivateData();
      this.getMapList();
    },
    //查看地图详情点击埋点
    mapDetailClick() {
      this.$log('map_details_check_click', 85415, { v7: 2 });
    },
    // 地图列表-接口
    async fetchMapList() {
      this.$toast.loading();
      const res = await getMapList({ ...this.searchParams });
      if (res.data) {
        const list = res.data.list;
        if (list && list.length) {
          this.mapList = list.map(item => ({
            ...item,
            time: formatDate(item.time * 1000),
          }));
        }
        this.dataTotal = res.data.total_count;
      }
      this.$toast.clear();
    },
    //获取全地图激励数据
    async getMotivateData() {
      const time = parseInt(new Date().getTime() / 1000);
      let data = {
        time: time,
        range: this.range,
      };
      const res = await getMotivate(data);
      if (res.data.ret === 0) {
        this.singelData = res.data.msg.single;
      }
    },
    regroupFilDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
    //获取作品列表
    async getMapList() {
      let start_time = parseInt(this.startDate.getTime() / 1000, 10);
      let end_time = parseInt(this.endDate.getTime() / 1000, 10);
      let data = {
        sort_type: this.pageInfo.sortType,
        page: this.pageInfo.page,
        page_size: this.pageInfo.pageSize,
        start_time: start_time,
        end_time: end_time,
      };
      try {
        const res = await getActiveData(data);
        if (res.data.list.length) {
          let list = res.data.list.map(item => {
            if (
              item.open_svr === 0 ||
              item.open_svr === 9 ||
              item.open_svr === 1
            ) {
              item.open_svr = '审核中';
            } else if (
              item.open_svr === 10 ||
              item.open_svr === 13 ||
              item.open_svr === 17
            ) {
              item.open_svr = '审核成功';
            } else if (
              item.open_svr === 2 ||
              item.open_svr === 3 ||
              item.open_svr === 7 ||
              item.open_svr === 8
            ) {
              item.open_svr = '隐藏';
            } else if (item.open_svr === 4 || item.open_svr === 14) {
              item.open_svr = '封禁';
            }
            if (
              Object.prototype.hasOwnProperty.call(this.singelData, item.id)
            ) {
              let obj = this.singelData[item.id];
              // item.nowcollect_counts =
              //   (obj.collect | 0) + item.nowcollect_counts;
              item.nowdownload_counts =
                (obj.download | 0) + item.nowdownload_counts;
              item.nowplay_counts = (obj.play_count | 0) + item.nowplay_counts;
              item.nowplay_times = (obj.play_time | 0) + item.nowplay_times;
              item.nowview_counts = (obj.browse | 0) + item.nowview_counts;
            }
            item.create_time = this.regroupFilDate(item.create_time);
            item.nowplay_times = (item.nowplay_times / 60).toFixed(2);
            //添加激励数据
            return item;
          });
          this.tableData = this.tableData.concat(list);
          this.refreshing = false;
          this.loading = false;
          this.pageInfo.total = res.data.total_count;
          if (this.tableData.length >= this.pageInfo.total)
            this.finished = true; //表示加载完成
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 跳转 地图详情
    navToDetail({ id }) {
      this.mapDetailClick();
      this.$router.push({ path: '/charts/map-detail', query: { id } });
    },
  },
};
</script>
<style src="../../assets/styles/filterPanel.less" lang="less" scoped></style>
<style lang="less" scoped>
.list-wrap {
  margin-top: -10px;
  padding: 0 4px;
  .download-data {
    display: flex;
    justify-content: flex-end;
    // margin-top: -200px;
    margin-bottom: 16px;
    margin-top: 24px;
    color: #2b6ddf;
    font-size: 28px;
  }
  .data-wrap {
    margin-top: 29px;
    .item {
      background: #ffffff;
      height: 340px;
      border-radius: 8px;
      margin-bottom: 20px;
      .top {
        display: flex;
        margin-left: 20px;
        margin-right: 20px;
        padding-top: 20px;
        padding-bottom: 25px;
        border-bottom: 1px solid #d8d8d8;
        .img-wrap {
          width: 267px;
          height: 150px;
          margin-right: 16px;
          position: relative;
          .map-img {
            width: 267px;
            height: 150px;
          }
          .corner {
            width: 70px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
        .right {
          .title {
            width: 364px;
            height: 80px;
            color: #000000;
            font-size: 28px;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            overflow: hidden;
          }
          .label {
            display: flex;
            font-size: 22px;
            color: #ffffff;
            margin-top: 8px;
            margin-bottom: 11px;
            .label1 {
              height: 30px;
              padding: 0px 21px;
              background: #0e96ff;
              border-radius: 4px;
              margin-right: 10px;
              display: flex;
              align-items: center;
            }
            .label2 {
              padding: 0px 19px;
              height: 30px;
              border-radius: 4px;
              background: #fea210;
              display: flex;
              align-items: center;
            }
            .label2.success {
              background: #2fce43;
            }
            .label2.fail {
              background: #ff5c5c;
            }
          }
          .time {
            font-size: 22px;
            color: #8c8c8c;
          }
        }
      }
      .bottom {
        padding-top: 18px;
        padding-left: 20px;
        font-size: 24px;
        color: #000000;
        .top-box {
          display: flex;
          margin-bottom: 18px;
          .value-custom {
            margin-left: 50px;
            margin-right: 50px;
          }
        }
        .bottom-box {
          display: flex;
          padding-bottom: 20px;
          .value-custom {
            margin-left: 50px;
            margin-right: 50px;
          }
        }
      }
    }
    .complete-tip {
      font-size: 24px;
      color: #8c8c8c;
      text-align: center;
    }
  }
  .pagenation {
    margin-top: 63px;
  }
}
.map-list-wrapper {
  // padding: 30px 20px;
  background-color: #fff;
  border-radius: 8px;

  .search-wrapper {
    display: flex;
    align-items: center;
  }

  .sort-type-item {
    width: 220px;
    margin-left: 20px;
    ::v-deep .van-dropdown-menu__bar {
      height: 60px;
    }
    ::v-deep .van-dropdown-menu__title {
      font-size: 26px;
    }
  }

  .table-wrapper {
    margin-top: 20px;
  }

  .map-name {
    color: #2b6ddf;
    text-decoration: underline;
  }

  .pagination {
    margin-top: 26px;
  }
}
</style>
